export default __webpack_public_path__ + "static/media/Hand-wraps of the Sepulcher.b6ffa3af.jpg";